import type { SxProps, Theme } from '@mui/material'
import { Box, Grid, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { Trans } from 'react-i18next'
import * as GA from '~/libs/ga'
import { Colors } from '~/libs/mui/theme'
import { useCommentsQuery } from '../hooks/comments/useCommentsQuery'
import VideoDetailCommentTab from './tabs/comments/VideoDetailCommentTab'
import VideoDetailRecommendsTab from './tabs/recommends/VideoDetailRecommendsTab'

const scrollStyle: SxProps<Theme> = {
  bgcolor: Colors.color272727,
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  // ヘッダー(64px) + コンテンツ余白(32px) + フッター(100px) + タブの高さ(46px) = 242px
  maxHeight: { xs: 'auto', sm: 'calc(100vh - 242px)' },
  overflow: 'scroll',
}

type Tab = 'recommend' | 'reviews'

const VideoDetailTabs: FC<{ id: string }> = ({ id }) => {
  const [selectedTab, setSelectedTab] = useState<Tab>('recommend')
  const { allCount } = useCommentsQuery(id)

  const handleSelectTab = useCallback(
    (tab: Tab) => {
      if (tab !== null) {
        GA.sendEvent({
          event: 'click',
          screen: 'movie_page',
          category: 'tab',
          action: `movie_page_${tab}`,
          label: `${id}`,
        })
        setSelectedTab(tab)
      }
    },
    [id],
  )

  return (
    <Box
      sx={{
        borderRadius: 2,
      }}
    >
      <Grid display='flex' justifyContent='center'>
        <ToggleButtonGroup
          color='primary'
          exclusive
          fullWidth
          value={selectedTab}
          onChange={(_, newSelectedTab) => handleSelectTab(newSelectedTab)}
        >
          <ToggleButton
            sx={{
              borderRadius: '8px 8px 0 0 !important',
              border: 'none',
            }}
            value={'recommend'}
          >
            <Trans i18nKey='recommends' />
          </ToggleButton>
          <ToggleButton
            sx={{
              borderRadius: '8px 8px 0 0 !important',
              border: 'none',
            }}
            value={'reviews'}
          >
            <Trans i18nKey='review' /> {allCount ?? 0}
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Box sx={scrollStyle} paddingTop={2} display={selectedTab === 'recommend' ? 'block' : 'none'}>
        <VideoDetailRecommendsTab id={id} />
      </Box>
      <Box sx={scrollStyle} display={selectedTab === 'reviews' ? 'block' : 'none'}>
        <VideoDetailCommentTab id={id} />
      </Box>
    </Box>
  )
}
export default VideoDetailTabs
